<template>
  <div >
    <h4 class="title-report">Response by Questions Smileys Details ({{type === 'devices' ? 'Devices' : 'Groups'}})</h4>
    <hr>
    <charts :options="chartOptions"></charts>
    <ModalDetailQuestionSmileys 
      :visible="showModal"
      :itemCategory="itemCategory"
      :indexCategory="itemIndex"
      :datesFiltering="dates"
      :typeFilter="type"
      :round_id="round_id"
      v-if="showModal" 
      v-on:close-modal="closeModalDetail"
    >
    </ModalDetailQuestionSmileys>
  </div>
</template>
<script>
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import ModalDetailQuestionSmileys from '@/components/client/rounds/dashboard/graphs/ModalDetailQuestionSmileys.vue';
export default {
  components: {
    MiniStatistic,
    ModalDetailQuestionSmileys
  },  
  props: {
    dates: {
      type: Object,
      default: function () { return { startDate: 'empty', endDate: 'empty' } },
      required: false,
    },
    type: {
      type: String,
      default: 'devices',
      required: false
    },
    round_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      itemCategory: null,
      itemIndex: null,
      dataResponse: null,
      chartOptions: {
        chart: {
          type: 'bar'
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{series.color}">{point.y} | {series.name}</span>: ({point.percentage:.0f}%)<br/>'
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            stacking: 'percent',
          },
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Bad',
          data: [],
          color: '#ed3b3b',
        }, {
          name: 'Poor',
          data: [],
          color: '#e87531',
        }, {
          name: 'Average',
          data: [],
          color: '#ffd700',
        }, {
          name: 'Good',
          data: [],
          color: '#407790', 
        }, {
          name: 'Excellent',
          data: [],
          color: '#138315'
        }, {
          name: 'Omitted',
          data: [],
          color: '#CDCDCD'
        }]
      }
    };
  },
  watch: {
    dates: {
      handler: function (val, oldVal) {
        this.loadData();
      },
      deep: true
    },

    type: {
      handler: function (val, oldVal) {
        this.loadData();
      },
      deep: true
    },
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      this.itemCategory = null;
      this.itemIndex = null;
      window.axios.get(`dashboards/round/${this.round_id}/responses-by-smileys-detail/${this.type}/${this.dates.startDate}/${this.dates.endDate}`).then(response => {
        this.dataResponse = response;
        this.chartOptions.xAxis.categories = this.dataResponse.data.data.names;
        this.chartOptions.series[0].data = this.dataResponse.data.data.byLocation.Bad;
        this.chartOptions.series[1].data = this.dataResponse.data.data.byLocation.Poor;
        this.chartOptions.series[2].data = this.dataResponse.data.data.byLocation.Average;
        this.chartOptions.series[3].data = this.dataResponse.data.data.byLocation.Good;
        this.chartOptions.series[4].data = this.dataResponse.data.data.byLocation.Excellent;
        this.chartOptions.series[5].data = this.dataResponse.data.data.byLocation.Omitted;
        let self = this;
        this.chartOptions.plotOptions.series.point = {
          events: {
            click: function () {
              self.showModal = true;
              self.itemCategory = this.category;
              self.itemIndex = self.dataResponse.data.data.id[this.x] ? self.dataResponse.data.data.id[this.x] : 'nogroup';         
            }
          },
        };
        this.$emit('endGraphByDevices');
      });
    },
    closeModalDetail: function () {
      this.showModal = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/dashboard/graphs/ResponsesDevicesByQuestionSmileys.vue